import $ from 'jquery'
import Tools from '../Tools'
/**
 * @module
 * @api
 */

/**
 * Tool API class
 *
 * @constructor
 */
export default function Toolbar(config) {
  $.extend(this, config || {})

  this.visibleTools = []
  this.stashedTools = []
  if (config.client.config.toolbar && !config.client.config.toolbar.drawtools) {
    this.visibleTools = []
  } else if (Array.isArray(config.client.config.toolbar.drawtools)) {
    this.visibleTools = config.client.config.toolbar.drawtools
  } else {
    this.visibleTools = Object.values(Tools)
  }

  this.listeners = []
  this.stashedListeners = []
}

/**
 * Activate tool
 * @param {string} tool tool to activate, see configuration of toolbar for available types
 * @memberof! module:api/Toolbar#
 * @api
 */
Toolbar.prototype.activateTool = function(tool) {
  this.client.toolbar.activateToolByName(tool)
}

/**
 * Deactivate tool
 * @memberof! module:api/Toolbar#
 * @api
 */
Toolbar.prototype.deactivateTool = function() {
  this.client.toolbar.deactivateActiveTool()
}

/**
 * Hide tool
 * @param {string} tool tool to hide, see configuration of toolbar for available types
 * @memberof! module:api/Toolbar#
 * @api
 */
Toolbar.prototype.hideTool = function(tool) {
  this.visibleTools = this.visibleTools.filter(v => v !== tool)
  this.client.toolbar.hideToolByName(tool)
}

/**
 * Show tool
 * @param {string} tool tool to hide, see configuration of toolbar for available types
 * @memberof! module:api/Toolbar#
 * @api
 */
Toolbar.prototype.showTool = function(tool) {
  if (!this.visibleTools.includes(tool)) {
    this.visibleTools = [...this.visibleTools, tool]
  }
  this.client.toolbar.showToolByName(tool)
}

/**
 * Add event listener
 * @param {string} type event type
 * @return {function} listener callback function
 * @memberof! module:api/Toolbar#
 * @api
 */
Toolbar.prototype.on = function(type, callback) {
  this.listeners.push({
    type: type,
    callback: callback
  })
}

/**
 * Remove event listener
 * @param {string} type event type
 * @return {function} listener callback function
 * @memberof! module:api/Toolbar#
 * @api
 */
Toolbar.prototype.un = function(type, callback) {
  this.listeners = this.listeners.filter(
    listener => listener.type !== type || listener.callback !== callback
  )
}

/**
 * Get active tool
 * @return {string} active tool
 * @memberof! module:api/Toolbar#
 * @api
 */
Toolbar.prototype.getActiveTool = function() {
  return this.client.toolbar.getToolId(this.client.toolbar.activeTool)
}

/**
 * Create an event trigger
 * @return {function} trigger function to handle events in toolbar
 */
Toolbar.prototype.createTrigger = function() {
  return e => {
    if (!e.type) {
      return
    }
    this.listeners
      .filter(listener => listener.type.toLowerCase() == e.type.toLowerCase())
      .forEach(listener => {
        listener.callback(e)
      })
  }
}

Toolbar.prototype.stashListeners = function() {
  this.stashedListeners = this.listeners
  this.listeners = []
  this.stashToolState()
}

Toolbar.prototype.popListeners = function() {
  this.listeners = this.stashedListeners
  this.stashedListeners = []
  this.popToolState()
}
Toolbar.prototype.stashToolState = function() {
  if (this.client.api.select.enabled) {
    if (!this.visibleTools.includes('select')) {
      this.visibleTools = [...this.visibleTools, 'select']
    }
  }
  this.stashedTools = [...this.visibleTools]
  this.visibleTools = []
}
Toolbar.prototype.popToolState = function() {
  this.stashedTools.forEach(tool => this.showTool(tool))
  this.stashedTools = []
}
